<template>
<div :class="[orderType == 'INDI' ? 'tbp' : 'group-tbp']">
  <div class="list" v-if="isGroup">
    <ul>
      <li :class="{ 'active': currentIndex === 0 }" @click="clickCurrent(0)"><span>团体订单</span></li>
      <li :class="{ 'active': currentIndex === 1 }" @click="clickCurrent(1)"><span>散客订单</span></li>
    </ul>
  </div>
  <div :class="['explain', isGroup ? 'groupMargin' : 'indiMargin']" >仅限90天内已使用的订单申请开票</div>
  <div v-if="orderList.length != 0">
    <div class="order-list">
      <div class="order-item" v-for="(item,index) in orderList" :key="item.orderId" :class="index === orderList.length-1 ? 'no-border':'border-devider'">
        <div class="select-btn">
          <input type="checkbox"
          class="check_box tui-checkbox"
          v-model.trim="item.checked"
          @change="itemChange(index)"/>
        </div>
        <div class="info">
          <div class="row orderSn">
            <span>订单编号</span>
            <span>{{item.orderSn}}</span>
          </div>
          <div class="row createtime">
            <span>创建时间</span>
            <span>{{item.createTime}}</span>
          </div>
        </div>
        <div class="price">￥{{item.availableAmount}}</div>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <input type="checkbox"
        class="check_box tui-checkbox"
        v-model.trim="checkedAll"
        @change="checkAll"/>
        <span class="allselect">
          全部选中
        </span>
        <span class="order-number" v-if="checkedOrderCount">
          {{checkedOrderCount}}个订单
        </span>
      </div>
      <div class="right">
        <span class="totalprice">
          ￥{{checkedTotalPrice ? checkedTotalPrice : '0.00'}}
        </span>
        <span class="next-step-btn" @click="toWriteInvoiceName">
          下一步
        </span>
      </div>
    </div>
  </div>
  <emptyContent text="您没有可开票的订单记录" v-else />
</div>
</template>

<script>
import { getGuideInfo } from '@/service/user/user.js';
import { getInvoiceOrderList } from '@/service/invoice/list.js';
export default {
  name: 'makeinvoice',
  data () {
    return {
      currentIndex: 0,
      isGroup:false,
      userInfo: {},
      orderList: [],
      checkedAll: false,
      checkedOrderCount: 0,
      checkedTotalPrice: 0,
      selectedRows:[],
      orderType: 'INDI'
    }
  },
  created() {
    if(window.sessionStorage.getItem('InvoiceOrderList')) {
      window.sessionStorage.removeItem('InvoiceOrderList');
    }
    if(window.sessionStorage.getItem('baseInfo')) {
      window.sessionStorage.removeItem('baseInfo');
    }
    if(window.sessionStorage.getItem('selectedInvoiceTitle')) {
      window.sessionStorage.removeItem('selectedInvoiceTitle');
    }
    this.judgeGroup()
  },
  mounted() {
    this.getOrderList()
  },
  methods:{
    clickCurrent(index){
      if(this.currentIndex === index)return;
      this.currentIndex = index;
      // this.individualOrderInfos = [];
      this.getOrderList();
    },
    async judgeGroup() {
      // 2023-09-05 jushuai 更改begin
      // const voucher = JSON.parse(window.localStorage.getItem('userInfo'));
      // let userInfo = null;
      // userInfo = JSON.parse(sessionStorage.getItem('groupUserInfo')) || null;


      let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      // if(!userInfo){
      //   const { data } = await getGuideInfo.call(this, {
      //     userType: 'weixin',
      //     userId: voucher.userId
      //   });
      //   userInfo = data;
      // };
      if(userInfo.extField1){
        this.isGroup = true
      }else{
        this.isGroup = false
      }
      // 2023-09-05 jushuai 更改 end
    },
    async getOrderList() {
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      const parameter = {
          userId: this.userInfo.userId
      };
      if(this.isGroup) {
        if(this.currentIndex) {
          parameter.orderType = 'INDI'
        }else{
          parameter.orderType = 'GROUP'
        }
      }else{
        parameter.orderType = 'INDI'
      }
      this.orderType = parameter.orderType
      const { data } = await getInvoiceOrderList.call(this, parameter);
      data.forEach(item => {
        item.checked = false
      });
      this.orderList = data
    },
    itemChange(index) {
        const preCheckedAll = this.checkedAll
        if (!this.orderList[index].checked) {
            this.checkedAll = false
        } else {
            this.checkedAll=!this.orderList.some(item => !item.checked)
        }
        this._handleSelectedRows()
    },
    checkAll() {
        this.orderList.forEach(item => {
            item.checked = this.checkedAll
        })
        this._handleSelectedRows()
    },
    _handleSelectedRows () {
      this.selectedRows = this.orderList.filter((item)=> item.checked == true)
      this.checkedOrderCount = this.selectedRows.length
      this.checkedTotalPrice = this.selectedRows.reduce((total, currentValue, currentIndex, arr) => {
          return currentValue['availableAmount'] ? ((total * 100 / 100) + (currentValue['availableAmount'] * 100 / 100)) : total;
      }, 0);
    },
    toWriteInvoiceName () {
      if (this.checkedOrderCount) {
        const SelectedInvoiceOrderList = []
        for(let item of this.selectedRows) {
          SelectedInvoiceOrderList.push(item.orderId)
        }
        const baseInfo = {
          orderType: this.orderType,
          orderCount: this.checkedOrderCount,
          totalPrice: this.checkedTotalPrice
        }
        window.sessionStorage.setItem('InvoiceOrderList', JSON.stringify(SelectedInvoiceOrderList));
        window.sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo));
        this.$router.push(`/wirteInvoiceName`);
      }else {
        this.$toast("请选择要开发票的订单");
      }
    }
  }
}
</script>

<style scoped lang='less'>
.group-tbp {
  padding-top: .533333rem;
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.tbp {
  padding-top: .533333rem;
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.list{
  height: .533333rem;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
}
.list>ul{
    padding: 0 .4rem;
    line-height: .64rem * 2;
    display: flex;
    background: #FFFFFF;
    justify-content: space-between;
    color: #333333;
    font-size: .213333rem * 2;
    li{
      flex: 1;
      text-align: center;
    }
    .active{
      // color: #3A3F5C;
      font-weight: 500;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        bottom: .106667rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.6rem;
        height: .08rem;
        background: #3B6D9C;
        border-radius: .08rem;
      }
    }
}
.explain{
  color: #999999;
  font-size: .32rem;
}
.groupMargin{
  margin: 1.2rem .266667rem .266667rem .266667rem;
}
.indiMargin{
  margin: .266667rem
}
.order-list {
  background: #FFFFFF;
  padding: .4rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;
  .order-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid rgba(151, 151, 151, .24);
    padding-bottom: .266667rem;
    .info{
      font-size: .32rem;
      color: #333;
      .row{
        margin-top: .32rem;
        margin-bottom: .32rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        white-space: nowrap;
        span:first-child{
          width: 1.333333rem;
        }
        span:last-child{
          flex: 1;
          padding-left: 0.5rem;
        }
      }
      .orderSn{
        font-size: .33rem;
        color: #333;
      }
      .createtime{
        font-size: .32rem;
        color: #999999;
      }
    }
    .price{
      font-size: .43rem;
      font-weight: bold;
      color: #3B6D9C;
    }
  }
  .border-devider{
    border-bottom: 1px solid rgba(151, 151, 151, .24);
  }
}
.bottom{
  height: 1.6rem + .346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .4rem;
  .left{
    .allselect{
      display: inline-block;
      margin-top: .04rem;
      padding: 0 .133333rem 0 .133333rem;
      font-size: .373333rem;
    }
    .order-number{
      display: inline-block;
      margin-top: .04rem;
      padding: 0 .133333rem 0 .133333rem;
      font-size: .373333rem;
      color: #3B6D9C;
    }
  }
  .right{
    margin-top: .106667rem;
    .totalprice{
      display: inline-block;
      font-size: .586667rem;
      color: #3B6D9C;
      font-weight: bold;
      margin-right: .133333rem;
      margin-top: .133333rem;
    }
    .next-step-btn{
      display: inline-block;
      border-radius: .6rem;
      text-align: center;
      padding: .2rem .533333rem;
      font-size: .4rem;
      background:#3B6D9C;
      color: #fff;
    }
  }
}
.tui-checkbox {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}
.tui-checkbox:checked {
  background: #DB4239;
  border: solid 1px #DB4239;
}
.tui-checkbox:checked::after {
  content: '';
  top: 0.1rem;
  left: 0.09rem;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 0.12rem;
  width: 0.25rem;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>
